import { createSlice } from "@reduxjs/toolkit";
import { ExpenseCategoryResponseDto } from "../../shared/dtos/expenseCategory/ExpenseCategoryResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const expenseCategorySlice = createSlice({
  name: "expenseCategory",
  initialState: getInitialCrudState<ExpenseCategoryResponseDto>(),
  reducers: {
    ...generateCrudReducers<ExpenseCategoryResponseDto>(),
  },
});

export const expenseCategoryActions = expenseCategorySlice.actions;
export default expenseCategorySlice.reducer;
